import { useEffect, useState } from 'react'
import { getDashboardStats, formatViewCount, type DashboardStats } from '../../../lib/dashboardAnalytics'

interface DashboardViewCountProps {
  dashboardId: string
}

export function DashboardViewCount({ dashboardId }: DashboardViewCountProps) {
  const [stats, setStats] = useState<DashboardStats | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await getDashboardStats(dashboardId)
        setStats(data)
      } catch (err) {
        console.error('Error loading view stats:', err)
      } finally {
        setLoading(false)
      }
    }

    fetchStats()
  }, [dashboardId])

  if (loading) {
    return (
      <div className="flex justify-between text-sm">
        <span className="text-gray-600">Visitas:</span>
        <span className="text-gray-400 animate-pulse">...</span>
      </div>
    )
  }

  if (!stats) {
    return (
      <div className="flex justify-between text-sm">
        <span className="text-gray-600">Visitas:</span>
        <span className="text-gray-400">N/A</span>
      </div>
    )
  }

  return (
    <div className="flex justify-between text-sm">
      <span className="text-gray-600">Visitas:</span>
      <div className="flex items-center gap-2">
        <span className="font-medium text-gray-900" title={`${stats.total_views} visitas totales`}>
          {formatViewCount(stats.total_views)}
        </span>
        {stats.total_views > 0 && (
          <span className="text-xs text-gray-500" title={`${stats.unique_views} visitantes únicos`}>
            ({stats.unique_views} únicos)
          </span>
        )}
      </div>
    </div>
  )
}
